import { DeviceService } from '../../http/device-service';
import { Selection } from './selection';

export async function findDefaultSelection(nodeId: number): Promise<Selection> {
    try {
        const res = await DeviceService.allByNode(nodeId);
        const devices: Array<{ device_id: number; node_id: number }> = res.data;
        if (devices.length > 0) {
            const d = devices[0];
            return { kind: 'device', deviceId: d.device_id, nodeId: d.node_id };
        }
    } catch {
        // fallthrough to node
    }
    return { kind: 'node', nodeId };
}
